/**
 * KEEP IT DUMB AND SIMPLE
 */ import { call, put, select, takeEvery } from 'redux-saga/effects';
import { request } from '../xhr';
import { makeXHRCall, setIsLoading, storeResult } from './actionCreators';
import { getIsLoading } from './selectors';
import { getFakeResponse } from './fakeResponses';
export function* makeXHRCallHandler({ payload: { endpoint , method , params , data , onComplete , onSuccess , onError  }  }) {
    const isLoading = yield select(getIsLoading, endpoint);
    if (isLoading) {
        return;
    }
    yield put(setIsLoading(endpoint));
    const result = yield call(request, {
        method,
        url: endpoint,
        params,
        data
    }, getFakeResponse(endpoint));
    yield put(storeResult({
        endpoint,
        result
    }));
    if (!result || result.error) {
        onError && onError(result);
    } else {
        onSuccess && onSuccess();
    }
    onComplete && onComplete();
}
export default function* saga() {
    yield takeEvery(makeXHRCall, makeXHRCallHandler);
}
